import styled from 'styled-components';

import { Body, H3 } from 'styles/typography';

// Shown when the client has no referral sources at all, which is an ordinary starting state rather
// than an error: the category is created on the first save.
export default function ReferralSourceEmptyState() {
  return (
    <Container data-testid='referral-sources-empty'>
      <H3>No referral sources yet</H3>
      <Message>
        Add the places referrals come from so they can be reported on, and so a referral naming one is matched to it
        automatically.
      </Message>
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 64px 24px;
  text-align: center;
`;

const Message = styled(Body)`
  max-width: 420px;
`;
